import { render, staticRenderFns } from "./StatsDump.vue?vue&type=template&id=5b953561"
import script from "./StatsDump.vue?vue&type=script&lang=ts"
export * from "./StatsDump.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports